import React from 'react';
import { Table, Button } from 'antd';
import { CircleDollarSign, Download, Check, X } from 'lucide-react';
import { StatusTag, EmptyState, CollapsibleCard } from '../../common';
import { downloadPrices, signedTone } from './priceTable.controller';

const productColumn = {
    title: 'Producto',
    dataIndex: 'name',
    key: 'name',
    fixed: 'left',
    width: 260,
    render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
};

const storePriceColumn = {
    title: 'PVP',
    dataIndex: 'storePrice',
    key: 'storePrice',
    width: 110,
    align: 'right',
    render: (text) => <span className="text-sm font-semibold text-surface-900 tabular-nums">${text}</span>
};

const suggestedPriceColumn = {
    title: 'Precio Sugerido',
    dataIndex: 'suggestedPrice',
    key: 'suggestedPrice',
    width: 140,
    align: 'right',
    render: (text) => <span className="text-sm text-surface-600 tabular-nums">${text}</span>
};

const priceVarColumn = {
    title: '% Var (PVP / P.S)',
    dataIndex: 'priceVar',
    key: 'priceVar',
    width: 150,
    align: 'right',
    render: (text) => (
        <StatusTag tone={signedTone(text, 'warning', 'success')} className="tabular-nums">
            {text}
        </StatusTag>
    )
};

const promoColumn = {
    title: 'Promoción',
    dataIndex: 'isPromo',
    key: 'isPromo',
    width: 120,
    align: 'center',
    render: (text) =>
        text === 'Si' ? (
            <StatusTag tone="success" icon={<Check />}>
                Sí
            </StatusTag>
        ) : (
            <StatusTag tone="neutral" icon={<X />}>
                No
            </StatusTag>
        )
};

const columns = [
    productColumn,
    storePriceColumn,
    {
        title: 'Margen Cliente',
        dataIndex: 'margin',
        key: 'margin',
        width: 140,
        align: 'right',
        render: (text) => (
            <StatusTag tone={signedTone(text, 'success', 'danger')} className="tabular-nums">
                {text}
            </StatusTag>
        )
    },
    suggestedPriceColumn,
    {
        title: 'Margen Sugerido',
        dataIndex: 'suggestedMargin',
        key: 'suggestedMargin',
        width: 150,
        align: 'right',
        render: (text) => <span className="text-sm text-surface-600 tabular-nums">{text}</span>
    },
    priceVarColumn,
    promoColumn
];

const tradColumns = [productColumn, storePriceColumn, suggestedPriceColumn, priceVarColumn, promoColumn];

export default function PriceTable({ prices, channel }) {
    return (
        <CollapsibleCard
            title="Precios"
            icon={<CircleDollarSign />}
            iconTone="success"
            flush
            badges={<StatusTag tone="neutral">{prices?.length || 0} productos</StatusTag>}>
            <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-surface-100">
                <span className="text-xs text-surface-500">
                    {channel === 'tradicional' ? 'Canal tradicional' : 'Canal moderno'} · PVP en piso vs. precio sugerido
                </span>
                <Button
                    icon={<Download />}
                    onClick={(e) => {
                        e.stopPropagation();
                        downloadPrices(prices);
                    }}>
                    Descargar Excel
                </Button>
            </div>
            <Table
                dataSource={prices}
                columns={channel === 'tradicional' ? tradColumns : columns}
                size="middle"
                pagination={{
                    pageSize: 10,
                    showTotal: (total) => `Total ${total} productos`
                }}
                scroll={{ x: 'max-content' }}
                locale={{ emptyText: <EmptyState icon={<CircleDollarSign />} title="Sin precios" description="No hay precios capturados en esta auditoría." /> }}
            />
        </CollapsibleCard>
    );
}
